import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { useConfirm } from "material-ui-confirm";

import confirmDialogStyleOptions from "../../../../../common/helpers/confirmDialogParams";
import { useDeleteSKU } from "../hooks/useDeleteSKU";
import { errorNotification } from "../../../../../common/variables/notification";

interface IRow {
  id?: string;
  rowId?: string;
  skuName?: string;
}

interface IDeleteSKUContainerProps {
  row: IRow;
}

const DeleteSKUContainer = ({ row }: IDeleteSKUContainerProps): JSX.Element => {
  const confirm = useConfirm();
  const { deleteSKU, loading } = useDeleteSKU();

  const handleDelete = (): void => {
    confirm({
      title: `Are you sure you want to delete "${row.skuName}"?`,
      confirmationText: "Delete",
      cancellationText: "Cancel",
      ...confirmDialogStyleOptions,
      confirmationButtonProps: {
        ...confirmDialogStyleOptions.confirmationButtonProps,
        color: "error",
      },
    })
      .then(async (): Promise<void> => {
        if (row.id) {
          try {
            await deleteSKU(row.id);
          } catch (error) {
            console.log("error", error);

            errorNotification("Error deleting SKU: " + error);
          }
        }
      })
      .catch(() => {
        // User clicked "Cancel" - do nothing
      });
  };

  return (
    <IconButton
      onClick={handleDelete}
      disabled={loading}
      color="error"
      size="small"
    >
      <DeleteIcon />
    </IconButton>
  );
};

export default DeleteSKUContainer;
